// Uncommon charm icons (24×24, id charm_<id>). Same house style as charms.ts:
// 1-px ink outline, light from top-left. Key: '.' transparent, 'o' ink outline, other chars per sprite.
import { sprite, type SpriteDef } from './types';

export const charmMagnifier = sprite(
  'charm_magnifier',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    w: 'white',
    i: 'ice',
    s: 'sky',
    u: 'blue',
    m: 'maroon',
    r: 'brick',
    h: 'rust',
  },
  [
    '........................',
    '......oooooo............',
    '....oolllgggoo..........',
    '...ollgggggggao.........',
    '..olgggooooggaao........',
    '..olgooiiisooaao........',
    '.olggoiwwissoaaco.......',
    '.olgoiwisssssoaco.......',
    '.olgoiissssssoaco.......',
    '.oggosssssssuoaco.......',
    '.ogaossssssuuoaco.......',
    '.ogaaosssuuuoacco.......',
    '..ogaoosuuuoocco........',
    '..ogaaaooooaccco........',
    '...ogaaaaaccccooo.......',
    '....ooaaacccoaglgo......',
    '......oooooo.oaglgo.....',
    '..............omrhro....',
    '...............omrhro...',
    '................omrhro..',
    '.................omrhro.',
    '..................omrro.',
    '...................ooo..',
    '........................',
  ],
);

export const charmGlasseye = sprite(
  'charm_glasseye',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    n: 'navy',
    c: 'cobalt',
    b: 'blue',
    k: 'sky',
    r: 'red',
    B: 'blood',
  },
  [
    '........................',
    '........................',
    '........................',
    '.........oooooo.........',
    '.......ooppppppoo.......',
    '......oppwwwpppppo......',
    '.....oppwwwwpppppso.....',
    '....oppwwwwpppppppso....',
    '....oppwwwpppnnnnpso....',
    '...opppwwpppnccccnpso...',
    '...opppppppncwcccbnso...',
    '...opppppppnccoobbnso...',
    '...orrpppppncboobknso...',
    '...opprrpppncbbbkknso...',
    '...oppppBpppnbbkknsso...',
    '....orpppppppnnnnsso....',
    '....oprpppppppppsslo....',
    '.....oppppppssssslo.....',
    '......ospppssssllo......',
    '.......oosssslloo.......',
    '.........oooooo.........',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmFlypaper = sprite(
  'charm_flypaper',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    m: 'olive',
    w: 'paper',
    r: 'red',
    v: 'vermilion',
    R: 'blood',
  },
  [
    '..........oooo..........',
    '.........olggao.........',
    '.........ogooao.........',
    '......oooooooooooo......',
    '......ovrrrrrrrRRo......',
    '......olgggggggaao......',
    '......ovrrrrrrrRRo......',
    '......oooooooooooo......',
    '.......olggggggao.......',
    '.......olggggaaao.......',
    '.......olgaaaggao.......',
    '.......oaaamgggao.......',
    '.......olgrorggao.......',
    '.......olwooowgao.......',
    '.......olwwowwgao.......',
    '.......olgwowggao.......',
    '.......olggmgggao.......',
    '.......olgggrorao.......',
    '.......olggwooowo.......',
    '.......olggwwowwo.......',
    '.......olmggwowao.......',
    '.......olgggggaao.......',
    '.......oooooooooo.......',
    '........................',
  ],
);

export const charmRosary = sprite(
  'charm_rosary',
  { o: 'ink', h: 'coral', m: 'cerise', d: 'crimson', l: 'lemon', g: 'gold', a: 'amber', c: 'copper' },
  [
    '.........oo..oo.........',
    '......ooohmoohmooo......',
    '.....ohmomdoomdohmo.....',
    '...ooomdooo..ooomdooo...',
    '..ohmooo........ooohmo..',
    '..omdo............omdo..',
    '..ooo..............ooo..',
    '.ohmo..............ohmo.',
    '.omdo..............omdo.',
    '..oooo............oooo..',
    '...ohmooo......ooohmo...',
    '...omdohmo.oo.ohmomdo...',
    '....ooomdoolgoomdooo....',
    '.......ooolggaooo.......',
    '..........oaco..........',
    '...........oo...........',
    '.........oolgoo.........',
    '........olllggao........',
    '........ogagaaco........',
    '.........oogaoo.........',
    '..........ogao..........',
    '..........oaco..........',
    '...........oo...........',
    '........................',
  ],
);

export const charmDentures = sprite(
  'charm_dentures',
  {
    o: 'ink',
    p: 'salmonPink',
    d: 'dustyPink',
    r: 'rose',
    m: 'mulberry',
    w: 'white',
    c: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    i: 'wine',
  },
  [
    '........................',
    '........................',
    '........................',
    '.....oooooooooooooo.....',
    '...ooppppdddddddrrroo...',
    '..oppppddddddddddrrrro..',
    '.oppdddddddddddddrrrrmo.',
    '.opddddddddddddddddrrmo.',
    '.orwcrwcrwwcwccrcsrcsmo.',
    '.oswcmwcmwwcwccmcsmcslo.',
    '.oswcmwcmwccccsmcsmcslo.',
    '.oscsicsiccscssississso.',
    '.oiiiiiiiiiiiiiiiiiiiio.',
    '.oiswciwciwcwcicsicslio.',
    '.orswcdwcdwcccdcsdcslmo.',
    '.oppddddddddddddddrrrmo.',
    '.opdddddddddddddddrrrmo.',
    '..opdddddddddddddrrrmo..',
    '...ooddrrrrrrrrmmmmoo...',
    '.....oooooooooooooo.....',
    '........................',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmBonesaw = sprite(
  'charm_bonesaw',
  {
    o: 'ink',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    y: 'brass',
    w: 'white',
    p: 'paper',
    s: 'steel',
    L: 'lilacGrey',
    r: 'brick',
    m: 'maroon',
    b: 'blood',
    R: 'red',
  },
  [
    '........................',
    '..oooo..................',
    '.oggaao.................',
    '..oacooooooooooooo......',
    '..owswwwwwpppppppso.....',
    '..owsssssssssssspsoo....',
    '..owsooooooooooopscmo...',
    '..owso.........opscrmo..',
    '..owso.........opscymo..',
    '..owso.........opscrmo..',
    '..owso.........opscrmo..',
    '..owsooooooooooopscrmo..',
    '..owypppRRppppppysocrmo.',
    '..owsLLLbbbLLLLLpsocrmo.',
    '...ooLoLoRoLoLoLooocrmo.',
    '.....o.ooRoo.o.o..ocymo.',
    '.........o........ocrmo.',
    '..................ocrmo.',
    '..................ocrmo.',
    '...................ocmo.',
    '....................oo..',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmMetronome = sprite(
  'charm_metronome',
  {
    o: 'ink',
    b: 'bronze',
    c: 'copper',
    r: 'brick',
    m: 'maroon',
    p: 'cream',
    d: 'sand',
    s: 'steel',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
  },
  [
    '..............o.........',
    '.............oso........',
    '..........ooooso........',
    '.........obccrso........',
    '.........obccrso........',
    '.........obccso.........',
    '........obdppsro........',
    '........obooooro........',
    '........oblggaro........',
    '.......obcgaaarro.......',
    '.......obcoooorro.......',
    '.......obcdpsprmo.......',
    '......obccppspcrmo......',
    '......obccdsppcrmo......',
    '......obccpsppcrmo......',
    '.....obcccdsppcrrmo.....',
    '.....obcccrgrccrrmo.....',
    '.....obcccccccrrrmo.....',
    '....obccccccccrrrrmo....',
    '...olggggggggggggggao...',
    '...obrrrrrrrrrrrrmmmo...',
    '...oooooooooooooooooo...',
    '........................',
    '........................',
  ],
);

export const charmSnakeoil = sprite(
  'charm_snakeoil',
  {
    o: 'ink',
    C: 'cream',
    S: 'sand',
    u: 'mud',
    i: 'pinkLilac',
    v: 'violet',
    P: 'purple',
    A: 'aubergine',
    w: 'white',
    r: 'red',
    b: 'blood',
    G: 'forest',
  },
  [
    '........................',
    '..........oooo..........',
    '.........oCSSuo.........',
    '.........oSSSuo.........',
    '........oivvvvPo........',
    '.........orrrbo.........',
    '.........oivvPo.........',
    '.........oivvPo.........',
    '.......ooivvvvPoo.......',
    '......oiivvvvvvPPo......',
    '.....oiwvvvvvvvPPAo.....',
    '.....oiCCCCCCCCCCAo.....',
    '.....oiCCGGGGGrCCAo.....',
    '.....oiCGGCCCCCCCAo.....',
    '.....ovCCGGGGGCCCAo.....',
    '.....ovCCCCCCGGCCAo.....',
    '.....ovCGGGGGGCCCAo.....',
    '.....ovCCCCCCCCCSAo.....',
    '.....ovSSSSSSSSSSAo.....',
    '.....ovvvvvvvvvPPAo.....',
    '......ovvPPPPPPAAo......',
    '.......oooooooooo.......',
    '........................',
    '........................',
  ],
);

export const charmCatbell = sprite(
  'charm_catbell',
  {
    o: 'ink',
    v: 'vermilion',
    r: 'red',
    b: 'blood',
    m: 'maroon',
    C: 'cream',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    w: 'white',
  },
  [
    '.........oooooo.........',
    '......ooobbbbbbooo......',
    '....oobbbbbbbbbbbboo....',
    '...ommmmmmmmmmmmmmmmo...',
    '..ommmmmmoooooommmmmmo..',
    '.ommmmooo......ooommmmo.',
    'olggmo............ommmo.',
    'ogoavo............ovvvvo',
    'oaacCo............oCbbo.',
    '.orrrvooo......ooovrbbo.',
    '..orrrvvvoooooovvvrrbo..',
    '...orrrCooolgoooCrrro...',
    '....ooboollgggaooboo....',
    '......oolwggggaaoo......',
    '......ollgggggaaao......',
    '......olggggggaaao......',
    '.....olccccccccccao.....',
    '.....oggggggggaaaco.....',
    '......ogogggggaoco......',
    '......oaaoooooocco......',
    '.......oaaaaaacco.......',
    '........oaaaacco........',
    '.........ooacoo.........',
    '...........oo...........',
  ],
);

export const charmHymnbook = sprite(
  'charm_hymnbook',
  { o: 'ink', k: 'cobalt', i: 'indigo', n: 'navy', l: 'lemon', g: 'gold', a: 'amber' },
  [
    '........................',
    '...oooooooooooooooo.....',
    '...oinkkkkkkkkkkkiooo...',
    '...oinkiiiiiiiiiinogao..',
    '...ogakiiiiiiiiiinogao..',
    '...oinkiiiilgniiinogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkillllggggnnogao..',
    '...oinkiggggaaaannogao..',
    '...oinkiinngannnnnogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkiiiiganiiinogao..',
    '...oinkiiiiaaniiinogao..',
    '...ogakiiiiinniiinogao..',
    '...oinkiiiiiiiiiinogao..',
    '...oininnnnnnnnnnnogao..',
    '...oooooooooooooooogao..',
    '....ogggggggggggggggao..',
    '....oaaaaaaaaaaaaaaaao..',
    '.....ooooooooooooooooo..',
    '........................',
  ],
);

export const charmLoadeddie = sprite(
  'charm_loadeddie',
  {
    o: 'ink',
    R: 'coral',
    r: 'red',
    b: 'blood',
    m: 'maroon',
    w: 'white',
    p: 'paper',
    d: 'dusk',
    l: 'lilacGrey',
  },
  [
    '........................',
    '........................',
    '........................',
    '.......ooooooooooooo....',
    '......oRRRRRRRRRRRoo....',
    '.....oRRRRRdlRRRRobo....',
    '....oRRRRRRRRRRRobbo....',
    '...ooooooooooooobbbo....',
    '...oRrrrrrrrrrrobbbo....',
    '...oRwwrrrrrwwrobbbo....',
    '...oRwprrrrrwprobbmo....',
    '...oRrrrrrrrrrrobbmo....',
    '...oRwwrrrrrwwrobbmo....',
    '...oRwprrrrrwprobmmo....',
    '...oRrrrrrrrrrrobmmo....',
    '...oRwwrrrrrwwrobmmo....',
    '...oRwprrrrrwprobmo.....',
    '...oRrrrrrrrrrbobo......',
    '...orbbbbbbbbbboo.......',
    '...ooooooooooooo........',
    '........................',
    '........................',
    '........................',
    '........................',
  ],
);

export const charmLedger = sprite(
  'charm_ledger',
  {
    o: 'ink',
    C: 'clover',
    f: 'forest',
    n: 'pine',
    r: 'red',
    b: 'blood',
    p: 'cream',
    S: 'sand',
    e: 'salmonPink',
    E: 'dustyPink',
    P: 'paper',
    s: 'steel',
    L: 'lilacGrey',
    d: 'dusk',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
  },
  [
    '........................',
    '...oooooooooooo.........',
    '..oCCCCCCCCCrCno........',
    '..oCffffffffrfno........',
    '..oCfoooooofrfno........',
    '..oCfoppppofrfno........',
    '..oCfoSSSpofrfno........',
    '..oCfoppppofrfno........',
    '..oCfoSSppofrfno...ooo..',
    '..oCfoooooofrfno..oeeEo.',
    '..oCffffffffrfno.oeEEo..',
    '..oCffffffffrfnooPsLo...',
    '..oCffffffffrfnolgao....',
    '..oCffffffffrfolgao.....',
    '..oCffffffffrolgao......',
    '..oCffffffffolgao.......',
    '..oCfffffffolgao........',
    '..oCffffffolgaoo........',
    '..oCfffffolgaono........',
    '..oCffffoppSofno........',
    '..onnnnopSoobnno........',
    '...oooodooooooo.........',
    '.......o................',
    '........................',
  ],
);

export const charmMothlamp = sprite(
  'charm_mothlamp',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    w: 'white',
    C: 'cream',
    A: 'apricot',
    O: 'orange',
    S: 'sand',
    M: 'mauveGrey',
    d: 'dusk',
    u: 'mud',
  },
  [
    '..............oo.o.o.oo.',
    '.............oCCoooooSSo',
    '........oooo.oCCCSuSSSMo',
    '.......olgacooSdSSuSSdMo',
    '.......oooooo.oSSMuMMMo.',
    '......olgggaco.oMMuMMo..',
    '.....olgggaacco.oouoo...',
    '......owCCCCAo....o.....',
    '.....owCCCOCCAo.........',
    '....owCClOglCAAo........',
    '...owCCllgllCCAAo.......',
    '...owCClllwllCAAo.......',
    '...owCCClgllCCAAo.......',
    '....oCCCCooCCAAo........',
    '.....oCAAAAAAAo.........',
    '.....olgggaacco.o.......',
    '....olggggaaaccogo......',
    '...olgggggaaaacco.......',
    '...ogggggaaaaccco.......',
    '....oaaaccccccco........',
    '....oooacccccooo........',
    '...olgggggaaaccco.......',
    '....oooooooooooo........',
    '........................',
  ],
);

export const charmFishhook = sprite(
  'charm_fishhook',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    d: 'dusk',
    r: 'red',
    b: 'blood',
    v: 'vermilion',
    g: 'gold',
  },
  [
    '........................',
    '.............oooo.......',
    '............owpslo......',
    '............opoolo......',
    '............opsslo......',
    '.............orboo......',
    '.............orbvro.....',
    '.............opsgvro....',
    '.....o.......opsogvro...',
    '....owo......opsoogvo...',
    '....owso.....opso.oro...',
    '....opsso....opso..o....',
    '....opsoso...opso.......',
    '....opsoo....opso.......',
    '....opso.....opso.......',
    '....opso.....opso.......',
    '....opso.....opso.......',
    '....opsso...oppso.......',
    '....opsssooossslo.......',
    '.....osssssssllo........',
    '......olllllddo.........',
    '.......ooooooo..........',
    '........................',
    '........................',
  ],
);

export const charmTipjar = sprite(
  'charm_tipjar',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    w: 'white',
    i: 'ice',
    T: 'teal',
    D: 'deepTeal',
    r: 'red',
    p: 'cream',
  },
  [
    '...........oo...........',
    '..........olgo..........',
    '..........ogao..........',
    '...........oo...........',
    '.....oooooooooooooo.....',
    '....owiiiiiiiiiiTTTo....',
    '....oiTTTTTTTTTTDDDo....',
    '.....oiDDDDDDDDDDTo.....',
    '....oiwDDDDDDDDDDDTo....',
    '...oirrrrrrrrrrrrrrTo...',
    '...oipooopopooppoopTo...',
    '...oippoppopooppoppTo...',
    '...oippoppopoppooppTo...',
    '...oirrrrrrrrrrrrrrTo...',
    '...oiDDDDDlggaDDDDDTo...',
    '...oiDDlgggalggaDDDTo...',
    '...oiDlggaaclgggacDTo...',
    '...oiclggaclggaclgaco...',
    '...oigaclggaclggaclao...',
    '...oaclggaclggaclgaco...',
    '....oTaaaccaaaccaaTo....',
    '.....oooooooooooooo.....',
    '........................',
    '........................',
  ],
);

export const charmWishbone = sprite(
  'charm_wishbone',
  { o: 'ink', w: 'cream', c: 'apricot', S: 'sand', M: 'mauveGrey' },
  [
    '...........oo...........',
    '..........owco..........',
    '.........owwcSo.........',
    '.........owccSo.........',
    '........owcccSSo........',
    '.......owccSScSMo.......',
    '.......owcSoocSMo.......',
    '......owcSo..ocSMo......',
    '......owcSo..ocSMo......',
    '.....owcSo....ocSMo.....',
    '.....owcSo....ocSMo.....',
    '....owcSo......ocSMo....',
    '....owcSo......ocSMo....',
    '...owcSo........ocSMo...',
    '...owcSo........ocSMo...',
    '...owcSo........ocSMo...',
    '..owcSo..........ocSMo..',
    '..owcSo..........ocSMo..',
    '..owcSo..........ocSMo..',
    '.owccSo..........occSMo.',
    '.occSSo..........oSSMMo.',
    '..oooo............oooo..',
    '........................',
    '........................',
  ],
);

export const charmLighter = sprite(
  'charm_lighter',
  {
    o: 'ink',
    O: 'orange',
    g: 'gold',
    y: 'lemon',
    w: 'white',
    B: 'blue',
    p: 'paper',
    s: 'steel',
    l: 'lilacGrey',
    d: 'dusk',
    a: 'amber',
    c: 'copper',
  },
  [
    '........o...............',
    '.......oOo..............',
    '......oOgOo.............',
    '......oOgyOo............',
    '.....oOgyyOo............',
    '.....oOywyOo............',
    '.....oOyygOo......oooo..',
    '.....ooByBooooo..owpslo.',
    '.....owppsslodso.owpslo.',
    '.....owoposlosdo.owpslo.',
    '.....owppsslooo..owpslo.',
    '.....owoposlo....owpslo.',
    '.....owppsslo...oowpslo.',
    '...ooooooooooooosoooooo.',
    '...owppppppppsloo.......',
    '...owppppypppslo........',
    '...owpppygappslo........',
    '...owppyggacpslo........',
    '...owpppgacppslo........',
    '...owppppcpppslo........',
    '...opssssssslllo........',
    '....ooooooooooo.........',
    '........................',
    '........................',
  ],
);

export const CHARM_SPRITES_U: SpriteDef[] = [
  charmMagnifier,
  charmGlasseye,
  charmFlypaper,
  charmRosary,
  charmDentures,
  charmBonesaw,
  charmMetronome,
  charmSnakeoil,
  charmCatbell,
  charmHymnbook,
  charmLoadeddie,
  charmLedger,
  charmMothlamp,
  charmFishhook,
  charmTipjar,
  charmWishbone,
  charmLighter,
];
